var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$canAny([
        _vm.permission.INTEGRA_MANAGER__OWNER.value,
        _vm.permission.INTEGRA_MANAGER__ADMIN.value
      ]))?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.dashboard'),
        icon: 'tim-icons icon-chart-pie-36',
        path: {name: 'shipper.dashboard'}
      }}}):_vm._e(),(_vm.$canAny([
        _vm.permission.INTEGRA_MANAGER__OWNER.value,
        _vm.permission.INTEGRA_MANAGER__ADMIN.value,
        _vm.permission.INTEGRA_MANAGER__FINANCIER.value ]))?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.control_tower'),
        icon: 'tim-icons icon-chart-bar-32',
      }}},[_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.kanban'),
          path: {name: 'shipper.control_tower'},
          isRoute: false,
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.map'),
          path: {name: 'shipper.order_in_progress'},
          isRoute: false,
        }}})],1):_vm._e(),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.requests'),
            icon: 'tim-icons icon-basket-simple',
          }}},[(_vm.$canAny([
          _vm.permission.INTEGRA_MANAGER__OWNER.value,
          _vm.permission.INTEGRA_MANAGER__ADMIN.value
        ]))?_c('sidebar-item',{attrs:{"material":true,"link":{
          name: _vm.$t('sidebar.request'),
          icon: 'playlist_add_check',
          path: {name: 'shipper.request'},
          isRoute: false,
        }}}):_vm._e(),(_vm.$canAny([
          _vm.permission.INTEGRA_MANAGER__OWNER.value,
          _vm.permission.INTEGRA_MANAGER__ADMIN.value
        ]))?_c('sidebar-item',{attrs:{"material":true,"link":{
          name: _vm.$t('sidebar.road_map'),
          icon: 'map',
          path: {name: 'shipper.road_map'},
          isRoute: false,
        }}}):_vm._e(),(_vm.$canAny([
          _vm.permission.INTEGRA_MANAGER__OWNER.value,
          _vm.permission.INTEGRA_MANAGER__ADMIN.value
        ]))?_c('sidebar-item',{attrs:{"material":true,"link":{
          name: _vm.$t('pages.import_nf.import_nf'),
          path: {name: 'shipper.request_import_nf'},
          isRoute: false,
        }}}):_vm._e()],1),(_vm.canSeePicking)?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.expedition'),
        icon: 'tim-icons icon-bag-16',
      }}},[_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.box'),
          path: {name: 'shipper.box'},
          isRoute: false,
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.products'),
          path: {name: 'shipper.product'},
          isRoute: false,
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.picking_kanban'),
          path: {name: 'shipper.picking_control_tower'},
          isRoute: false,
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.picking_packing'),
          path: {name: 'shipper.picking'},
          isRoute: false,
        }}})],1):_vm._e(),(_vm.$canAny([
        _vm.permission.INTEGRA_MANAGER__OWNER.value,
        _vm.permission.INTEGRA_MANAGER__ADMIN.value,
        _vm.permission.INTEGRA_MANAGER__QUOTATION_APPROVER_USER.value
      ]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.ADVANCED.value))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.shippings'),
            icon: 'tim-icons icon-coins',
          }}},[(_vm.$canAny([
          _vm.permission.INTEGRA_MANAGER__OWNER.value,
          _vm.permission.INTEGRA_MANAGER__ADMIN.value ]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.PREMIUM.value))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.simulation'),
          path: {name: 'shipper.order_simulation'},
          isRoute: false,
      }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: this.$t('sidebar.quotes'),
          path: {name: 'shipper.order_quotes'},
          isRoute: false,
        }}}),(_vm.$canAny([
          _vm.permission.INTEGRA_MANAGER__OWNER.value,
          _vm.permission.INTEGRA_MANAGER__ADMIN.value ]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.PREMIUM.value))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.approve_table'),
          path: {name: 'shipper.simulation.approve_table'},
          isRoute: false,
      }}}):_vm._e(),(_vm.$canAny([
          _vm.permission.INTEGRA_MANAGER__OWNER.value,
          _vm.permission.INTEGRA_MANAGER__ADMIN.value ]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.PREMIUM.value))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.approve_route_table'),
          path: {name: 'shipper.approve_route_table'},
          isRoute: false,
      }}}):_vm._e()],1):_vm._e(),(_vm.$canAny([
        _vm.permission.INTEGRA_MANAGER__OWNER.value,
        _vm.permission.INTEGRA_MANAGER__ADMIN.value,
        _vm.permission.INTEGRA_MANAGER__SHIPPER_COMMERCIAL.value,
        _vm.permission.INTEGRA_MANAGER__FINANCIER.value
      ]))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.orders'),
            icon: 'tim-icons icon-delivery-fast',
          }}},[_c('sidebar-item',{attrs:{"link":{
          name:_vm.$t('sidebar.all_orders'),
          path: {name: 'shipper.order'},
          isRoute: false,
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.occurrences'),
          path: {name: 'shipper.order_occurrences'},
          isRoute: false,
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('pages.fob_order.title'),
          path: {name: 'shipper.fob_order'},
          isRoute: false
        }}}),(_vm.$canAny([
          _vm.permission.INTEGRA_MANAGER__OWNER.value,
          _vm.permission.INTEGRA_MANAGER__ADMIN.value ]))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.canceled'),
          path:{name: 'shipper.order_canceled'},
          isRoute: false,
        }}}):_vm._e(),(_vm.$canAny([
          _vm.permission.INTEGRA_MANAGER__OWNER.value,
          _vm.permission.INTEGRA_MANAGER__ADMIN.value ]))?_c('sidebar-item',{attrs:{"material":true,"link":{
          name: _vm.$t('sidebar.address'),
          icon: 'list',
          path: {name: 'shipper.address_alias'}
        }}}):_vm._e(),(_vm.$canAny([
          _vm.permission.INTEGRA_MANAGER__OWNER.value,
          _vm.permission.INTEGRA_MANAGER__ADMIN.value ]))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.not_imported_files'),
          path: {name: 'shipper.not_imported_files'},
        }}}):_vm._e()],1):_vm._e(),(_vm.$canAny([
          _vm.permission.INTEGRA_MANAGER__OWNER.value,
          _vm.permission.INTEGRA_MANAGER__ADMIN.value,
          _vm.permission.INTEGRA_MANAGER__FINANCIER.value,
          _vm.permission.INTEGRA_MANAGER__FINANCIER_BASIC.value ]))?_c('sidebar-item',{attrs:{"material":true,"link":{
          name: _vm.$t('sidebar.reports'),
          icon: 'list',
        }}},[(_vm.$canAny([
          _vm.permission.INTEGRA_MANAGER__OWNER.value,
          _vm.permission.INTEGRA_MANAGER__ADMIN.value
        ]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.ADVANCED.value))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.list_documents'),
          path: {name: 'shipper.orders_documents'},
          isRoute: false,
        }}}):_vm._e(),(_vm.$canAny([
          _vm.permission.INTEGRA_MANAGER__OWNER.value,
          _vm.permission.INTEGRA_MANAGER__ADMIN.value
        ]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.BASIC.value))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.orders'),
            icon: 'tim-icons icon-notes',
            path:{name: 'shipper.order_export'},
          }}}):_vm._e(),(_vm.$canAny([
          _vm.permission.INTEGRA_MANAGER__OWNER.value,
          _vm.permission.INTEGRA_MANAGER__ADMIN.value
        ]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.BASIC.value))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.requests'),
            icon: 'tim-icons icon-notes',
            path:{name: 'shipper.request_export'},
          }}}):_vm._e(),(_vm.$canAny([
          _vm.permission.INTEGRA_MANAGER__OWNER.value,
          _vm.permission.INTEGRA_MANAGER__ADMIN.value,
          _vm.permission.INTEGRA_MANAGER__FINANCIER.value,
          _vm.permission.INTEGRA_MANAGER__FINANCIER_BASIC.value
        ]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.PRO.value))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.canhoto_check'),
          icon: 'assignment_turned_in',
          path: {name: 'shipper.canhoto'}
        }}}):_vm._e(),(_vm.$canAny([
          _vm.permission.INTEGRA_MANAGER__OWNER.value,
          _vm.permission.INTEGRA_MANAGER__ADMIN.value
        ]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.PRO.value))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.nf_files'),
          icon: 'assignment_turned_in',
          path: {name: 'shipper.nf_files'}
        }}}):_vm._e()],1):_vm._e(),(_vm.$canAny([
        _vm.permission.INTEGRA_MANAGER__OWNER.value,
        _vm.permission.INTEGRA_MANAGER__ADMIN.value
      ]))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.exports_imports'),
            icon: 'tim-icons icon-notes',
          }}},[(_vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.ADVANCED.value))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.list_documents'),
          icon: 'tim-icons icon-notes',
          path:{name: 'shipper.orders_documents_export'},
        }}}):_vm._e(),(_vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.BASIC.value))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.orders'),
          icon: 'tim-icons icon-notes',
          path:{name: 'shipper.order_reports'},
        }}}):_vm._e(),(_vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.BASIC.value))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.requests'),
          icon: 'tim-icons icon-notes',
          path:{name: 'shipper.request_reports'},
        }}}):_vm._e(),(_vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.BASIC.value))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.occurrences'),
          icon: 'tim-icons icon-notes',
          path:{name: 'shipper.occurrence_reports'},
        }}}):_vm._e(),(_vm.$canAny([
        _vm.permission.INTEGRA_MANAGER__OWNER.value,
        _vm.permission.INTEGRA_MANAGER__ADMIN.value
      ]))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.transporters'),
          icon: 'tim-icons icon-notes',
          path:{name: 'shipper.transporters_export'},
        }}}):_vm._e()],1):_vm._e(),(_vm.$canAny([
        _vm.permission.INTEGRA_MANAGER__OWNER.value,
        _vm.permission.INTEGRA_MANAGER__ADMIN.value
      ]))?_c('sidebar-item',{attrs:{"material":true,"link":{
            name: _vm.$t('sidebar.users_and_companies'),
            icon: 'group',
          }}},[(_vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.BASIC.value) && _vm.user.user.company.parent_id == null)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.branches'),
            path: {name: 'shipper.subsidiary'},
            isRoute: false
          }}}):_vm._e(),_c('sidebar-item',{attrs:{"material":true,"link":{
            name: _vm.$t('sidebar.users'),
            path: {name: 'shipper.user'},
            isRoute: false
          }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.transporters'),
          path: {name: 'shipper.transporter'},
          isRoute: false,
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.suppliers'),
          path: {name: 'shipper.supplier'},
          isRoute: false,
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.final_customers'),
          path: {name: 'shipper.final_customer'},
          isRoute: false,
        }}})],1):_vm._e(),(_vm.canSeeSatisfactionSurvey)?_c('sidebar-item',{attrs:{"material":true,"link":{
        name: _vm.$t('sidebar.satisfaction_survey'),
        icon: 'list',
      }}},[_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.satisfaction_survey_results'),
          path: {name: 'shipper.satisfaction_survey_results'}
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.satisfaction_survey_answers'),
          path: {name: 'shipper.satisfaction_survey_answers'}
        }}})],1):_vm._e(),(_vm.$canAny([
        _vm.permission.INTEGRA_MANAGER__OWNER.value,
        _vm.permission.INTEGRA_MANAGER__ADMIN.value
      ]) && _vm.$hasPlanOrBetter(_vm.plans.LOGISTIC_MANAGER.BASIC.value))?_c('sidebar-item',{attrs:{"material":true,"link":{
            name: _vm.$t('sidebar.settings'),
            icon: 'settings',
            path: {name: 'shipper.configuration'}

          }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }